{
  "title": "Documenten",
  "description": "De kennisbank die agents doorzoeken: upload bestanden, orden ze in mappen en houd de index actueel.",
  "tabs": {
    "documents": "Documenten",
    "index": "Index & planning"
  },
  "actions": {
    "close": "Sluiten",
    "delete": "Verwijderen",
    "download": "Downloaden",
    "editText": "Tekst bewerken",
    "move": "Verplaatsen",
    "new": "Nieuw",
    "open": "Openen",
    "showInFolder": "Toon in map"
  },
  "tree": {
    "label": "Mappen",
    "all": "Alle documenten",
    "breadcrumbs": "Mappad",
    "collapse": "Inklappen",
    "expand": "Uitklappen",
    "actions": "Acties voor {{name}}"
  },
  "folders": {
    "root": "Hoofdniveau",
    "new": "Nieuwe map",
    "newSub": "Nieuwe submap",
    "newTitle": "Nieuwe map",
    "newDescription": "Mappen ordenen documenten; agents kunnen binnen een map zoeken.",
    "create": "Map aanmaken",
    "parent": "Locatie",
    "name": "Naam",
    "namePlaceholder": "bijv. handboek",
    "delete": "Map verwijderen",
    "deleteTitle": "Map “{{name}}” verwijderen?",
    "deleteWithDocs_one": "Dit verwijdert de map, de submappen en {{count}} document daarin definitief.",
    "deleteWithDocs_other": "Dit verwijdert de map, de submappen en alle {{count}} documenten daarin definitief.",
    "deleteEmpty": "De map is leeg en wordt verwijderd.",
    "missing": {
      "title": "Map niet gevonden",
      "description": "“{{path}}” bestaat niet (meer)."
    }
  },
  "move": {
    "renameOrMove": "Hernoemen of verplaatsen",
    "documentTitle": "Document verplaatsen of hernoemen",
    "folderTitle": "Map verplaatsen of hernoemen",
    "description": "Staat nu op {{path}}.",
    "destination": "Doelmap",
    "fileName": "Bestandsnaam",
    "fileNameHint": "Geüploade bestanden behouden hun extensie.",
    "submit": "Verplaatsen"
  },
  "newDoc": {
    "action": "Nieuw document",
    "title": "Nieuw document",
    "description": "Schrijf een tekstdocument direct in de kennisbank. Namen zonder extensie worden Markdown (.md).",
    "create": "Document aanmaken",
    "content": "Inhoud",
    "contentHint": "Markdown wordt ondersteund."
  },
  "validation": {
    "segment": "Gebruik één naam zonder schuine strepen."
  },
  "documents": {
    "title": "Documenten",
    "columns": {
      "name": "Naam",
      "index": "Indexstatus",
      "size": "Grootte",
      "updated": "Bijgewerkt"
    },
    "count_one": "{{count}} document gevonden",
    "count_other": "{{count}} documenten gevonden",
    "docCount_one": "Bevat {{count}} document",
    "docCount_other": "Bevat {{count}} documenten",
    "search": "Zoek op naam of titel…",
    "searchIn": "Zoek in {{folder}}…",
    "deleteTitle": "“{{name}}” verwijderen?",
    "deleteDescription": "Het document en de zoekindex ervan worden verwijderd. Agents kunnen het niet meer vinden.",
    "empty": {
      "title": "Nog geen documenten",
      "description": "Upload pdf's, Word-, spreadsheet-, Markdown- of tekstbestanden, of sleep ze hierheen."
    },
    "emptyFolder": {
      "title": "Deze map is leeg",
      "description": "Sleep bestanden hierheen of upload ze naar deze map."
    }
  },
  "indexState": {
    "indexed": "Geïndexeerd",
    "indexedHint": "Ingebed met het huidige model; vindbaar op betekenis en trefwoorden.",
    "pending": "Niet geïndexeerd",
    "pendingHint": "Gewijzigd of nieuw sinds de laatste indexering; tot dan alleen vindbaar op trefwoorden.",
    "failed": "Mislukt",
    "failedHint": "Indexeren mislukt.",
    "keyword": "Alleen trefwoorden",
    "keywordHint": "Er is geen embeddingmodel ingesteld, dus zoeken gebeurt op trefwoorden."
  },
  "mode": {
    "hybrid": "Hybride zoeken",
    "keyword": "Zoeken op trefwoord"
  },
  "detail": {
    "preview": "Voorbeeld",
    "details": "Gegevens",
    "content": "Documenttekst",
    "noText": "Geen tekst",
    "noTextHint": "Uit dit bestand kon geen tekst worden gehaald.",
    "extracted": "Tekst uit het geüploade bestand. Download het origineel voor de exacte opmaak.",
    "truncated": "De eerste {{shown}} van {{total}} tekens worden getoond. Download het bestand om alles te zien.",
    "reindexHint": "Opslaan markeert het document voor herindexering.",
    "indexError": "Indexeren mislukt:",
    "path": "Pad",
    "type": "Soort",
    "size": "Grootte",
    "characters": "Tekens",
    "chunks": "Fragmenten",
    "indexStatus": "Indexstatus",
    "indexedAt": "Geïndexeerd",
    "notIndexed": "Nog niet",
    "created": "Aangemaakt",
    "updated": "Bijgewerkt",
    "sha": "SHA-256-controlesom",
    "source": "Bron",
    "sourceText": "In de app geschreven",
    "sourceUpload": "Geüpload bestand",
    "metadata": "Titel & tags",
    "titleField": "Titel",
    "titleHint": "Wordt in zoekresultaten getoond in plaats van de bestandsnaam.",
    "tags": "Labels",
    "related": "Gerelateerde documenten",
    "noRelated": "Geen gerelateerde documenten.",
    "relatedMissing": "“{{path}}” bestaat niet meer."
  },
  "upload": {
    "action": "Uploaden",
    "title": "Documenten uploaden",
    "description": "Bestanden met dezelfde naam in de doelmap worden vervangen.",
    "destination": "Doelmap",
    "drop": "Sleep bestanden hierheen of klik om te kiezen",
    "types": "PDF, Word, Excel, Markdown, tekst, CSV, JSON en code · max. 50 MB per bestand",
    "dropHere": "Loslaten om te uploaden naar {{folder}}",
    "progress": "Uploadvoortgang",
    "remove": "{{name}} verwijderen",
    "saved": "Geüpload",
    "error": "Mislukt",
    "skipped": "Overgeslagen",
    "reject": {
      "type": "Dit bestandstype wordt niet ondersteund.",
      "size": "Groter dan 50 MB.",
      "empty": "Het bestand is leeg."
    },
    "partial": "{{saved}} geüpload, {{failed}} mislukt — zie de lijst voor details.",
    "done_one": "{{count}} document geüpload",
    "done_other": "{{count}} documenten geüpload",
    "failed_one": "{{count}} bestand kon niet worden geüpload",
    "failed_other": "{{count}} bestanden konden niet worden geüpload",
    "submit_one": "{{count}} bestand uploaden",
    "submit_other": "{{count}} bestanden uploaden",
    "summary_one": "{{count}} bestand · {{size}}",
    "summary_other": "{{count}} bestanden · {{size}}"
  },
  "index": {
    "title": "Zoekindex",
    "description": "Documenten worden in fragmenten opgedeeld en ingebed zodat agents ze op betekenis vinden. Zoeken op trefwoord werkt altijd.",
    "run": "Wijzigingen indexeren",
    "running": "Bezig met indexeren…",
    "more": "Meer indexacties",
    "rebuild": "Volledige index opnieuw opbouwen",
    "rebuildTitle": "Volledige index opnieuw opbouwen?",
    "rebuildDescription": "Elk document wordt opnieuw ingebed; dat kost embeddingtokens. Zoeken blijft werken tijdens het opbouwen.",
    "notConfigured": "Stel eerst een embeddingmodel in.",
    "summary": "{{indexed}} van {{total}} documenten geïndexeerd",
    "keywordOnly": "Geen embeddingmodel ingesteld — alleen zoeken op trefwoord.",
    "lastRun": "Laatste run",
    "stale_one": "{{count}} te indexeren",
    "stale_other": "{{count}} te indexeren",
    "failed_one": "{{count}} mislukt",
    "failed_other": "{{count}} mislukt"
  },
  "embedding": {
    "mode": "Zoekmodus",
    "provider": "Aanbieder",
    "model": "Embeddingmodel",
    "dimensions": "Dimensies",
    "modelDefault": "Standaard van model",
    "none": "Niet ingesteld",
    "configure": "Embeddinginstellingen",
    "unusable": "Embeddingconfiguratie is niet bruikbaar",
    "notConfiguredTitle": "Alleen zoeken op trefwoord",
    "notConfigured": "Kies een embeddingprovider en -model in de organisatie-instellingen om semantisch (hybride) zoeken in te schakelen."
  },
  "schedule": {
    "title": "Planning",
    "description": "Gewijzigde documenten automatisch indexeren.",
    "enabled": "Automatisch indexeren",
    "enabledHint": "Voert met het interval hieronder een incrementele indexering uit.",
    "needsModel": "Werkt pas als er een embeddingmodel is ingesteld.",
    "every": "Elke",
    "unit": "Eenheid",
    "hours": "Uren",
    "days": "Dagen",
    "lastRun": "Laatste run",
    "nextRun": "Volgende run"
  },
  "jobs": {
    "title": "Indexeringen",
    "description": "De 20 meest recente indexeringstaken.",
    "full": "Volledig opnieuw",
    "incremental": "Incrementeel",
    "preparing": "Voorbereiden…",
    "progress": "{{done}} van {{total}} documenten",
    "progressLabel": "Indexvoortgang",
    "status": {
      "pending": "In wachtrij",
      "running": "Bezig",
      "completed": "Voltooid",
      "failed": "Mislukt"
    },
    "trigger": {
      "manual": "Handmatig gestart",
      "schedule": "Gepland"
    },
    "columns": {
      "status": "Toestand",
      "kind": "Soort",
      "documents": "Documenten",
      "chunks": "Fragmenten",
      "duration": "Duur",
      "started": "Gestart"
    },
    "empty": {
      "title": "Nog geen indexeringen",
      "description": "Runs verschijnen hier zodra je de kennisbank indexeert."
    },
    "failedCount_one": "{{count}} mislukt",
    "failedCount_other": "{{count}} mislukt"
  },
  "stats": {
    "documents": "Documenten",
    "indexed": "Geïndexeerd",
    "chunks": "Fragmenten",
    "storage": "Opslag",
    "byType": "Bestandstypen",
    "byTypeDescription": "Waar de kennisbank uit bestaat.",
    "lastIndexed": "Laatst geïndexeerd",
    "lastUpdated": "Laatste wijziging",
    "folders_one": "in {{count}} map",
    "folders_other": "in {{count}} mappen",
    "embedded_one": "{{count}} ingebed",
    "embedded_other": "{{count}} ingebed",
    "chars_one": "{{count}} teken tekst",
    "chars_other": "{{count}} tekens tekst",
    "typeLine_one": "{{count}} bestand · {{size}}",
    "typeLine_other": "{{count}} bestanden · {{size}}"
  },
  "search": {
    "title": "Kennis doorzoeken",
    "description": "Doorzoek de kennisbank zoals agents dat doen: op betekenis en op trefwoorden.",
    "placeholder": "Stel een vraag of zoek op trefwoorden…",
    "submit": "Zoeken",
    "clear": "Zoekopdracht wissen",
    "folder": "Map",
    "allFolders": "Alle mappen",
    "limit": "Aantal resultaten",
    "hybridHint": "Combineert semantische gelijkenis (embeddings) met trefwoordovereenkomsten.",
    "keywordHint": "Alleen trefwoordovereenkomsten: stel een embeddingmodel in voor semantisch zoeken.",
    "idle": {
      "title": "Doorzoek de kennisbank",
      "description": "Resultaten tonen de best passende passages, gegroepeerd per document."
    },
    "noDocs": {
      "title": "De kennisbank is leeg",
      "description": "Upload eerst documenten en doorzoek ze dan hier.",
      "action": "Naar documenten"
    },
    "empty": {
      "title": "Geen resultaten",
      "description": "Niets in de kennisbank past bij “{{query}}”. Probeer andere woorden of een andere map."
    },
    "similarity": "{{value}}% gelijkend",
    "similarityHint": "Cosinusgelijkenis tussen de vraag en deze passage.",
    "keywordMatch": "Trefwoordmatch",
    "keywordMatchHint": "Deze passage bevat woorden uit de zoekopdracht.",
    "limitValue_one": "{{count}} resultaat",
    "limitValue_other": "{{count}} resultaten",
    "resultCount_one": "{{count}} passage gevonden",
    "resultCount_other": "{{count}} passages gevonden",
    "resultDocs_one": "verdeeld over {{count}} document",
    "resultDocs_other": "verdeeld over {{count}} documenten",
    "moreChunks_one": "+ nog {{count}} passende passage",
    "moreChunks_other": "+ nog {{count}} passende passages"
  },
  "toasts": {
    "created": "{{path}} aangemaakt",
    "updated": "{{path}} opgeslagen",
    "deleted": "{{path}} verwijderd",
    "folderCreated": "Map {{path}} aangemaakt",
    "folderDeleted": "Map {{path}} verwijderd",
    "moved": "Verplaatst naar {{to}}",
    "indexStarted": "Indexeren gestart",
    "rebuildStarted": "Volledige herbouw gestart",
    "scheduleSaved": "Planning opgeslagen"
  }
}
